import { slugify } from "../../utils/slugify.js";
import type { Category } from "../Category.js";
import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { categoryNameMap } from "../names/categoryNameMap.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getCategoryPath(tenant: Tenant, category: Category): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: `/${slugify(categoryNameMap[category][Locale.cs])}`,
	};

	return getPathInLocale(tenant.locale, pathMap);
}
